import React from "react";
import ServeIQLoader from "./serveiqLoader";
import "./GridSectionLoader.css";

/**
 * Loading overlay scoped to a content region (e.g. filters + grid).
 * Parent sets position context; when loading is true, a minimum height is applied so the overlay is visible even if children render empty.
 */
const GridSectionLoader = ({
  loading,
  children,
  className = "",
  minHeight = "240px",
  message = "",
}) => {
  return (
    <div
      className={`grid-section-loader ${className}`.trim()}
      style={{
        position: "relative",
        ...(loading ? { minHeight } : {}),
      }}
      aria-busy={loading}
    >
      {children}
      {loading && (
        <div className="grid-section-loader__overlay" role="status" aria-live="polite">
          <div className="grid-section-loader__panel">
            <ServeIQLoader size={64} />
            {message ? (
              <p className="grid-section-loader__message mb-0">{message}</p>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default GridSectionLoader;
